import css from 'styled-jsx/css';

const styles = css.global`.canais-atendimento-custom-tab {
    justify-content: flex-start!important;
    overflow: auto!important;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    z-index: 400;
    position: relative;
}

.bg-gray {
    background: #FBFBFB;
    position: relative;
    padding: 32px 0 0;
}

.custom-tabs.tabs-container {
    padding: 0 0 24px 0;
}

/* .content-qrcode {
    z-index: 99;
} */

.canais-atendimento-qrcode-title {
    color:#C00;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
    margin: 0;
}

.canais-atendimento-qrcode-paragrafo {
    color:#444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin-top: 8px;
    margin-bottom: 48px;
}


.bg-santander-symbol {
    position: relative;
    overflow: hidden;
}

.bg-santander-symbol .bg-santander-symbol-img {
    position: absolute;
    top: 520px;
    width: 836px;
    opacity: .1;
    right: -330px;
}

@media (min-width: 992px) {
    .bg-gray {
        padding: 40px 0 0;
    }

    .custom-tabs.tabs-container {
        padding: 0 0 40px 0;
    }

    
    .bg-santander-symbol .bg-santander-symbol-img {
        top: 110px;
        width: 1400px;
        right: -240px;
    }

}

@media (min-width: 1280px) {
    .ctn-home-24 {
        padding-right: 0;
        padding-left: 0;
    }

  }`;

export default styles;